export enum BLUETOOTH_PASSWORD_SOURCE {
    Unknown = "Unknown",
    Factory = "Factory",
    Fota = "Fota",
    None = "None",
    Tct = "Tct"
}
